import styled, { keyframes } from 'styled-components';
import { Text, Title, Section as ThemeSection } from '../../utils/theme';

export const Section = styled(ThemeSection)`
  min-height: 0vh;
  position: relative;
  overflow: hidden;
  height: 48vw;
  box-shadow: 0 0 5vw 5vw #090C1B inset;

  @media (max-width: 600px) {
    height: 70vw;
  }
`;

export const SponsorTitle = styled(Title)`
    position: absolute;
    top: 0vw;
    left: 0vw;
    width: 100vw;
    font-size: 3.5vw;

    @media (max-width: 600px) {
      position: absolute;
      top: 0vw;
      left: 10vw;
      width: 80vw;
      font-size: 5vw;      
    }
`;

export const SponsorText = styled(Text)`
  position: absolute;
  top: 7.5vw;
  font-size: 1.5vw;
  text-align: center;
  width: 60vw;

  @media (max-width: 600px) {
    position: absolute;
    top: 10vw;
    left: 10vw;
    width: 80vw;
    font-size: 3.4vw;
  }
`;

export const SponsorsImage = styled.img`
  position: absolute;
  top: 19vw;
  left: 10vw;
  width: 80vw;

  @media (max-width: 600px) {
    top: 40vw;
    left: 5vw;
    width: 90vw;
  }
`;

export const pulsing = keyframes`
  0%, 100% {
    transform: scale(1);
  } 
  50% {
    transform: scale(0.97);
  }
`;
  
export const SponsorAurora = styled.img`
  z-index: -1;
  position: absolute;
  top: -32vw;
  width: 100vw;

  animation: ${pulsing} 15s infinite ease-in-out;

  @media (max-width: 600px) {
    left: -50vw;
    top: -40vw;
    width: 150vw;
  }
`;
